import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import emergencyLogoSrc from '../../assets/images/emergency-logo.png';
import styles from './PreCheckoutV8.css';

const TOOLS = [
    {
        id: 2,
        icon: 'mail',
        name: 'Real-Time Email Leak Monitor',
        description: 'Monitors known databases and alerts you if your personal accounts appear in data breaches.',
        status: 'Ready to launch'
    },
    {
        id: 3,
        icon: 'shieldCheckOutline',
        name: 'Anti-Spy Privacy Shield',
        description: 'Provides simple guides and settings checks to help keep your daily online activity private.',
        status: 'Ready to launch'
    },
    {
        id: 4,
        icon: 'book',
        name: 'Personalized Safety Handbook',
        description: 'A tailored, plain-English guide to secure your digital life. Includes official cybersecurity instructions, top scam schemes to watch out for, and an actionable daily safety checklist.',
        status: 'Ready to download'
    }
];

function PreCheckoutV8({ onSubmit, isPending }) {
    useEffect(() => {
        document.getElementById('root').scrollIntoView({ block: 'start', behavior: 'instant' });

        logEvent(EVENT_TYPES.SALE_PRE_CHECKOUT_PAGE_VISITED);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.root}>
                <h1 className={styles.title}>
                    The plan was created for you
                </h1>
                <div className={styles.planBlock}>
                    <div className={styles.planBlockRow}>
                        <img
                            src={emergencyLogoSrc}
                            alt='emergency'
                        />
                        <p>Your Protection Tools are Ready</p>
                    </div>
                </div>
                <h2 className={styles.subtitle}>
                    What's included in your plan:
                </h2>
                <ul className={styles.list}>
                    {TOOLS.map(tool => (
                        <li key={tool.id} className={styles.item}>
                            <div className={styles.itemHeader}>
                                <span className={styles.iconWrapper}>
                                    <Icon
                                        name={tool.icon}
                                        className={styles.icon}
                                    />
                                </span>
                                <span className={styles.status}>{tool.status}</span>
                            </div>
                            <p className={styles.name}>{tool.name}</p>
                            <p className={styles.description}>{tool.description}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={styles.footer}>
                <div className={styles.footerWrapper}>
                    <Button
                        label='Continue'
                        onClick={onSubmit}
                        className={styles.button}
                        isLoading={isPending}
                        inSlide
                    />
                </div>
            </div>
        </div>
    );
}

PreCheckoutV8.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isPending: PropTypes.bool
};

export {
    PreCheckoutV8
};
